import punycode from 'punycode';

const toPunycode = (domain: string) => punycode.toASCII(domain.toLowerCase());

export default toPunycode;
